import type {
	PharmacyPickerGroupShortcut,
	PharmacyPickerNoResultsRecovery,
} from "~/features/products/pharmacy-picker/pharmacy-picker.types";
import { PharmacyPickerAvailableCount } from "~/features/products/pharmacy-picker/pharmacy-picker-available-count.component";
import { PharmacyPickerGroupButton } from "~/features/products/pharmacy-picker/pharmacy-picker-group-button.component";
import { PharmacyPickerNoResultsMessage } from "~/features/products/pharmacy-picker/pharmacy-picker-no-results-message.component";
import { TopPharmacySection } from "~/features/products/pharmacy-picker/top-pharmacy-section.component";
import { WhyTopPharmacyCollapsible } from "~/features/products/pharmacy-picker/why-top-pharmacy-collapsible.component";

type PharmacyPickerNoResultsProps = {
	groupShortcuts: PharmacyPickerGroupShortcut[];
	onSelectGroup: (groupId: string) => void;
	/**
	 * When false, the "no results" message is rendered elsewhere (the picker's
	 * white search header) and only the group shortcuts are shown here.
	 */
	showMessage?: boolean;
	hideWhyTopCollapsible?: boolean;
	recovery?: PharmacyPickerNoResultsRecovery;
};

export function PharmacyPickerNoResults({
	groupShortcuts,
	onSelectGroup,
	showMessage = true,
	hideWhyTopCollapsible = false,
	recovery,
}: PharmacyPickerNoResultsProps) {
	const allGroup = groupShortcuts.find((group) => group.id === "all");
	return (
		<div
			className={`flex min-h-full flex-1 flex-col gap-4 bg-gray-100 px-4 pt-3 ${showMessage ? "pb-4" : ""}`}
			data-testid="pharmacy-picker-no-results"
		>
			{showMessage && <PharmacyPickerNoResultsMessage recovery={recovery} />}
			{recovery ? null : (
				<div className="flex flex-col gap-2">
					{hideWhyTopCollapsible ? (
						<PharmacyPickerAvailableCount
							count={0}
							total={allGroup?.count ?? 0}
						/>
					) : (
						<WhyTopPharmacyCollapsible
							leftContent={<TopPharmacySection count={0} />}
						/>
					)}
					<div className="flex flex-col gap-2">
						{groupShortcuts.map((group) => (
							<PharmacyPickerGroupButton
								key={group.id}
								group={group}
								onClick={() => onSelectGroup(group.id)}
							/>
						))}
					</div>
				</div>
			)}
		</div>
	);
}
